import { VoiceProvider } from "@/enums/agencies";

/**
 * Sample GET URLs must include `provider` so Cartesia (and OpenAI) IDs are not
 * mis-inferred from the voice id shape. Org-created voices also pass `orgId`.
 */
export function buildVoiceSampleUrl(
  voiceId: string,
  lang: string,
  options?: {
    provider?: VoiceProvider | string;
    orgId?: string;
    isOrganizationVoice?: boolean;
  }
): string {
  const params = new URLSearchParams();
  if (options?.provider) {
    params.set("provider", String(options.provider));
  }
  if (options?.isOrganizationVoice && options.orgId) {
    params.set("orgId", options.orgId);
  }
  const qs = params.toString();
  return `/api/voices/${encodeURIComponent(voiceId)}/sample/${encodeURIComponent(lang)}${
    qs ? `?${qs}` : ""
  }`;
}
